export const CARD_ID_ATTRIBUTE = 'data-card-id';
